import { TranslationBuilder } from '~/code/components/Translation'

export default TranslationBuilder.create<{
    message(openModal: () => void, tryAgain: () => void): React.ReactNode
}>()
